import { Form } from "react-bootstrap"
import { useState, useEffect } from "react"

const ControlInput = (props) => {
  const {
    label,
    name,
    feedback,
    validTest,
    setValid,
    isValid,
    blurAll,
    setData,
    ...inputProps
  } = props

  const [isTouched, setIsTouched] = useState(false)

  const handleOnChange = (e) => {
    setData(e.target.value)
    setValid(name, validTest(e.target.value))
  }

  const handleOnBlur = (e) => {
    setIsTouched(true)
    setValid(name, validTest(e.target.value))
  }

  useEffect(() => {
    if (blurAll) {
      setIsTouched(true)
    }
  }, [blurAll])

  return (
    <Form.Group className="mb-2 w-100" controlId={name}>
      {label && <Form.Label className="mt-2 fw-semibold text-muted">{label}</Form.Label>}
      <Form.Control
        onBlur={handleOnBlur}
        isInvalid={!isValid && isTouched}
        onChange={handleOnChange}
        {...inputProps}
      />
      <Form.Control.Feedback type="invalid" className="fw-semibold">
        <i>{feedback}</i>
      </Form.Control.Feedback>
    </Form.Group>
  )
}
export default ControlInput